var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.thumbnail && _vm.imgLoaded)?_c('img',{attrs:{"src":_vm.thumbnail,"alt":_vm.name}}):(_vm.typeIcon)?_c('svg-icon',{attrs:{"icon":_vm.typeIcon,"cls":_vm.typeCls}}):_c('space-icon',{attrs:{"space":_vm.space}})}
var staticRenderFns = []

export { render, staticRenderFns }